// Ornamental filigree divider echoing the Culture Antique emblem.
// Use <Flourish /> for a centered diamond motif, or <Flourish label="…" />
// to frame a small eyebrow label with symmetric scrollwork.

function Arm({ side }) {
  return (
    <svg
      viewBox="0 0 140 24"
      className="h-5 w-20 text-gold sm:w-28 md:w-36"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      style={side === "left" ? { transform: "scaleX(-1)" } : undefined}
      aria-hidden="true"
    >
      <path d="M0 12 H84" strokeOpacity="0.5" />
      <path d="M84 12 c 10 0 15 -8 25 -8 c 8 0 11 9 2 10 c -6 1 -9 -5 -2 -8" />
      <path d="M96 12 c 6 5 13 5 20 1" strokeOpacity="0.55" />
      <circle cx="122" cy="12" r="1.6" fill="currentColor" stroke="none" />
    </svg>
  );
}

export default function Flourish({ label, className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-3 md:gap-4 ${className}`}>
      <Arm side="left" />
      {label ? (
        <span className="whitespace-nowrap font-sans text-[10px] uppercase tracking-luxe text-gold-deep">
          {label}
        </span>
      ) : (
        <svg
          viewBox="0 0 24 24"
          className="h-3.5 w-3.5 shrink-0 text-gold"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.1"
          aria-hidden="true"
        >
          <path d="M12 2 L20 12 L12 22 L4 12 Z" />
          <circle cx="12" cy="12" r="2.4" fill="currentColor" stroke="none" />
        </svg>
      )}
      <Arm side="right" />
    </div>
  );
}
